<template>
    <div>

        <div class="container">

            <div class="video-container">
                <iframe v-if="embed" width="560"
                        height="315"
                        :src="'https://www.youtube.com/embed/' + embed"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
            </div>

            <div class="row blocs">
                <div class="col-md-4 col-12 bloc">
                    <a :href="youtubeUrl" target="_blank">
                        <img class="hvr-grow-rotate" src="/img/logo-youtube.png" alt="Logo Youtube">
                        <h2 class="hvr-hang">jobouille</h2>
                    </a>
                </div>
                <div class="col-md-4 col-12 bloc">
                    <a :href="facebookurl" target="_blank">
                        <img class="hvr-grow-rotate" src="/img/logo-facebook.png" alt="Logo Facebook">
                        <h2 class="hvr-hang">@jobouille</h2>
                    </a>
                </div>
                <div class="col-md-4 col-12 bloc">
                    <a :href="twitterUrl" target="_blank">
                        <img class="hvr-grow-rotate" src="/img/logo-twitter.png" alt="Logo Twitter">
                        <h2 class="hvr-hang">@jobouille</h2>
                    </a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                embed: '',
                youtubeUrl: 'https://www.youtube.com/c/jobouille',
                facebookurl: 'https://www.facebook.com/jobouille',
                twitterUrl: 'https://twitter.com/jobouille',
            }
        },
        mounted() {
            axios.get('last-video').then(response => {
                this.embed = response.data['embed'];
            })
        }
    }
</script>
